<template>
    <v-container>
        <div id="posts">
            <v-card class="post" v-for="message in socialMessages" :key="message.id" outlined>
                <v-card-title class="headline">{{ message.sender.name }} <v-chip v-if="message.sender.role" color="secondary" class="mx-2" small>{{ message.sender.role }}</v-chip></v-card-title>
                <v-card-subtitle>
                    Posted on day {{ message.gameDay }}.
                </v-card-subtitle>
                <v-card-text class="body-1">
                    {{ message.content }}
                </v-card-text>
            </v-card>

            <v-alert type="info" v-if="socialMessages.length == 0">
                There are no social media posts yet. Be the first by clicking
                the pencil icon in the bottom right.
            </v-alert>
        </div>

        <v-fab-transition>
            <v-btn color="secondary" fixed bottom right fab @click.stop="dialog = true">
                <v-icon>mdi-pencil</v-icon>
            </v-btn>
        </v-fab-transition>

        <v-dialog v-model="dialog" max-width="350">
            <SendMessage type="social"/>
        </v-dialog>
    </v-container>
</template>

<script>
import SendMessage from '../components/SendMessage.vue';
import { mapState } from 'vuex';

export default {
    name: "SoMed",
    data: () => ({
        dialog: false
    }),
    components: {
        SendMessage
    },
    computed: mapState([
        "socialMessages"
    ]),
    sockets: {
        send_event(state) {
            if (state == "sent") { this.dialog = false; }
        }
    }
}
</script>

<style scoped>
    .post {
        margin-bottom: 15px;
    }
</style>
